(function(){
'use strict';

scFundraiserBlockSettings.$inject = ["scFroalaOptions"];
function scFundraiserBlockSettings(scFroalaOptions) {
  return {
    scope: true,
    templateUrl: 'global/objects/scBlock/types/fundraiser/settings',
    controller: ['$scope', 'scCampaignsTemplateService', function ($scope, scCampaignsTemplateService) {
      $scope.headlineOptions = scFroalaOptions({
        type: 'bare-headline'
      }, {
        heightMin: null,
        charCounterCount: true,
        charCounterMax: 200
      });

      $scope.titleOptions = scFroalaOptions({
        type: 'bare-headline'
      }, {
        heightMin: null,
        charCounterCount: true,
        charCounterMax: 180
      });

      $scope.postBodyOptions = scFroalaOptions({ type: 'update-paragraph' }, {
        heightMin: 200,
        heightMax: 200,
        ariaLabel: 'Default story body'
      });

      $scope.fundraiserPhotoMediaManagerOptions = {
        title: 'Select a Fundraiser Default Photo',
        image: {
          guide: {
            title: 'Fundraiser Default Photo',
            message: 'Brand your campaign with a unique logo.',
            size: '320 x 320 pixels'
          },
          crop: true
        }
      };

      $scope.fundraiserCoverPhotoMediaManagerOptions = {
        title: 'Select a Cover Photo',
        image: {
          guide: {
            title: 'Fundraiser Cover Photo',
            message: 'Brand your campaign with a unique cover photo.',
            size: '1400 x 460 pixels'
          }
        }
      };

      $scope.block.sectionOpen = null;

      // Initialize lock state
      if (SC.campaign && SC.campaign.campaignTemplateData) {
        var lockFundraiserBlock = scCampaignsTemplateService.getBlockByType('fundraiser');
        $scope.bgLock = lockFundraiserBlock.item_attributes.background.locked || lockFundraiserBlock.item_attributes.background.image.locked;
      }
    }],

    link: function link() {}
  };
}

angular.module('classy').directive('scFundraiserBlockSettings', scFundraiserBlockSettings);
})();